import Vue from 'vue'
import Router from 'vue-router'
import CarList from '@/pages/car/CarList.vue'
import CarForm from '@/pages/car/CarForm.vue'
import CarDetail from '@/pages/car/CarDetail.vue'
import CarIndex from '@/pages/car/CarIndex.vue'
import CarOldForNewForm from '@/pages/car/CarOldForNewForm.vue'
import CarOldForNewDetail from '@/pages/car/CarOldForNewDetail.vue'
// import LiveIndex from '@/components/LiveIndex.vue'
// import TicketDetailPage from '@/components/TicketDetailPage.vue'
// import MerchantPage from '@/components/MerchantPage.vue'
// import MePage from '@/components/MePage.vue'
import HouseIndex from '@/pages/house/Index.vue'
import HouseList from '@/pages/house/List.vue'
import HouseForm from '@/pages/house/Form.vue'
import HouseDetail from '@/pages/house/Detail.vue'
const RunnerIndex = () => import('@/pages/runner/Index.vue')
const RunnerForm = () => import('@/pages/runner/Form.vue')
const RunnerList = () => import('@/pages/runner/List.vue')
const RunnerDetail = () => import('@/pages/runner/Detail.vue')
const SafeSxForm = () => import('@/pages/safesx/Form.vue')
const YmwhxjIndex = () => import('@/pages/ymwhxj/Index.vue')
const YmwhxjForm = () => import('@/pages/ymwhxj/Form.vue')
const YmwhxjList = () => import('@/pages/ymwhxj/List.vue')
const YmwhxjDetail = () => import('@/pages/ymwhxj/Detail.vue')

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/h5/form',
  routes: [
    {
      path: '/car/index',
      name: 'CarIndex',
      component: CarIndex
    },
    {
      path: '/car/:fid',
      name: 'CarList',
      component: CarList,
      // children: [
      //   {
      //     path: 'form',
      //     name: 'CarForm',
      //     component: CarForm,
      //   },
      //   {
      //     path: 'detail/:form_id',
      //     name: 'CarDetail',
      //     component: CarDetail,
      //   },
      // ]
    },
    {
      path: '/car/form/:form_id',
      name: 'CarForm',
      component: CarForm,
    },
    {
      path: '/car/detail/:form_id',
      name: 'CarDetail',
      component: CarDetail,
    },
    {
      path: '/car/oldfornew/:form_id',
      name: 'CarOldForNewForm',
      component: CarOldForNewForm,
    },
    {
      path: '/car/oldfornewdetail/:form_id',
      name: 'CarOldForNewDetail',
      component: CarOldForNewDetail,
    },
    {
      path: '/house/index',
      name: 'HouseIndex',
      component: HouseIndex
    },
    {
      path: '/house/:fid',
      name: 'HouseList',
      component: HouseList,
    },
    {
      path: '/house/form/:fid/:form_id',
      name: 'HouseForm',
      component: HouseForm,
    },
    {
      path: '/house/detail/:fid/:form_id',
      name: 'HouseDetail',
      component: HouseDetail,
    },
    {
      path: '/runner/form/:form_id',
      name: 'RunnerForm',
      component: RunnerForm
    },
    {
      path: '/runner/index',
      name: 'RunnerIndex',
      component: RunnerIndex
    },
    {
      path: '/runner/list',
      name: 'RunnerList',
      component: RunnerList
    },
    {
      path: '/runner/detail/:form_id',
      name: 'RunnerDetail',
      component: RunnerDetail,
    },
    {
      path: '/ymwhxj/form/:form_id',
      name: 'YmwhxjForm',
      component: YmwhxjForm
    },
    {
      path: '/ymwhxj/index',
      name: 'YmwhxjIndex',
      component: YmwhxjIndex
    },
    {
      path: '/ymwhxj/list',
      name: 'YmwhxjList',
      component: YmwhxjList
    },
    {
      path: '/ymwhxj/detail/:form_id',
      name: 'YmwhxjDetail',
      component: YmwhxjDetail,
    },
    {
      path: '/quiz/safesx/:fid',
      name: 'SafeSxForm',
      component: SafeSxForm,
    }
  ]
})
